import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  DialogContent,
  DialogActions,
  DialogTitle,
  Typography,
  Divider,
  Box,
  TextField,
} from '@mui/material';
import { useDispatch } from 'react-redux';
import actions from '@src/redux/actions';
import { CancelRounded } from '@mui/icons-material';
import { COLOR } from '@src/styles/color';
import apis from '@src/apis';
import { MAX_LENGTH_TITLE } from '@src/constants/request';
import { StyledButton, StyledDialog } from './index.style';

const EditTitleRequestDialog = ({
  request,
  open,
  onClose,
  updateRequest,
  onCloseActionDrawer,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const { id: requestId, title: currentTitle } = request;
  const [title, setTitle] = useState(currentTitle);

  const updateRequestTitle = async (e) => {
    try {
      e.stopPropagation();
      if (title === currentTitle) {
        onClose();
        return;
      }
      if (title.length === 0) {
        setTitle(title);
        onClose();
        return;
      }
      if (title.length > MAX_LENGTH_TITLE) {
        dispatch(
          actions.noti.push({
            severity: 'warning',
            message: 'updateTitleMaxLength',
            value: MAX_LENGTH_TITLE,
          }),
        );
        return;
      }
      const response = await apis.requests.updateRequest(requestId, {
        title,
      });
      if (!response?.status) {
        dispatch(
          actions.noti.push({
            severity: 'error',
            message: 'updateFailure',
          }),
        );
        return;
      }
      dispatch(
        actions.noti.push({
          severity: 'success',
          message: 'updateSuccess',
        }),
      );
      updateRequest(requestId, { title });
      onClose();
      onCloseActionDrawer();
    } catch (error) {
      dispatch(
        actions.noti.push({
          severity: 'error',
          message: error?.response?.data?.error_message || 'updateFailure',
        }),
      );
    }
  };

  const onChangeTitle = (e) => {
    if (e.target.value.length > MAX_LENGTH_TITLE) {
      setTitle(e.target.value.slice(0, MAX_LENGTH_TITLE));
      return;
    }
    setTitle(e.target.value);
  };

  return (
    <StyledDialog open={open} onClose={onClose} fullWidth>
      <DialogTitle className="wrap-title">
        <Box className="title">
          <Typography className="text-title">{t('editTitle')}</Typography>
        </Box>
        <CancelRounded sx={{ color: COLOR.darkV2[32] }} onClick={onClose} />
      </DialogTitle>
      <Divider />
      <DialogContent className="wrap-content">
        <TextField
          value={title}
          onChange={onChangeTitle}
          className="input"
          placeholder={t('enterTitle')}
          InputProps={{ sx: { borderRadius: 12, height: 44, width: '100%' } }}
        />
      </DialogContent>
      <DialogActions className="wrap-actions">
        <StyledButton
          variant="contained"
          onClick={updateRequestTitle}
          bgrDisble={COLOR.yellow[32]}
          colorDisable="#3c164e99"
          disabled={title.length === 0}
        >
          {t('saveName')}
        </StyledButton>
      </DialogActions>
    </StyledDialog>
  );
};

export default EditTitleRequestDialog;
